import React from 'react'
import './WhyChooseUs.css'
import box1img from '../../images/box1-img.png'
import box2img from '../../images/box2-img.png'
import box3img from '../../images/box3-img.png'
import box4img from '../../images/box4-img.png'
import Tilt from 'react-parallax-tilt'

const WhyChooseUs = () => {

    return (
        <div className='why-choose-us'>

            <div className='why-choose-us-content'>

                <div className='why-choose-us-heading container'><h2>WHY CHOOSE LATA 777</h2></div>

                <div className='why-choose-us-boxes'>

                    <Tilt glareEnable={true} glareMaxOpacity={0.35} className='why-choose-us-box1'>

                        <div className='why-choose-us-box inner-element'>

                            <div className='box-img'><img src={box1img} /></div>
                            <div className='box-title'><h6>APP AVAILABLE FOR IOS & ANDROID</h6></div>

                        </div>

                    </Tilt>

                    <Tilt glareEnable={true} glareMaxOpacity={0.35} className='why-choose-us-box2'>

                        <div className='why-choose-us-box'>

                            <div className='box-img'><img src={box2img} /></div>
                            <div className='box-title'><h6>SELECT LANGUAGE OF YOUR CHOICE</h6></div>

                        </div>

                    </Tilt>

                    <Tilt glareEnable={true} glareMaxOpacity={0.35} className='why-choose-us-box3'>

                        <div className='why-choose-us-box'>

                            <div className='box-img'><img src={box3img} /></div>
                            <div className='box-title'><h6>50K+ HAPPY PLAYERS</h6></div>

                        </div>

                    </Tilt>

                    <Tilt glareEnable={true} glareMaxOpacity={0.35} className='why-choose-us-box4'>

                        <div className='why-choose-us-box'>

                            <div className='box-img'><img src={box4img} /></div>
                            <div className='box-title'><h6>MINIMUM DEPOSITE ₹100</h6></div>

                        </div>

                    </Tilt>

                </div>

            </div>

        </div>
    )
}

export default WhyChooseUs
